import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

type CoordinateInput = string | number | null | undefined;

function normalizeCoordinateValue(value: CoordinateInput): number | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed.length) {
      return undefined;
    }
    const normalized = trimmed.replace(',', '.');
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

function isWithinRange(value: number, min: number, max: number): boolean {
  return value >= min && value <= max;
}

export function toValidLatitude(value: CoordinateInput): number | undefined {
  const normalized = normalizeCoordinateValue(value);
  if (normalized === undefined) {
    return undefined;
  }
  return isWithinRange(normalized, -90, 90) ? normalized : undefined;
}

export function toValidLongitude(value: CoordinateInput): number | undefined {
  const normalized = normalizeCoordinateValue(value);
  if (normalized === undefined) {
    return undefined;
  }
  return isWithinRange(normalized, -180, 180) ? normalized : undefined;
}

function createCoordinateValidator(
  normalizer: (value: CoordinateInput) => number | undefined,
  errorKey: string,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value as CoordinateInput;
    if (raw === null || raw === undefined || raw === '') {
      return null;
    }
    return normalizer(raw) !== undefined ? null : { [errorKey]: true };
  };
}

export function mapLatitudeValidator(): ValidatorFn {
  return createCoordinateValidator(toValidLatitude, 'mapLatitude');
}

export function mapLongitudeValidator(): ValidatorFn {
  return createCoordinateValidator(toValidLongitude, 'mapLongitude');
}
